// extracted by mini-css-extract-plugin
export default {"absoluteDiv":"UserList_absoluteDiv__t24RA","toastStyle":"UserList_toastStyle__uW1aZ","DeleteButton":"UserList_DeleteButton__yxYnQ","EditButton":"UserList_EditButton__ssRK0"};